module.exports = __webpack_public_path__ + "img/logo_marca_white.48411b48.png";